import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
const popover = ({ ContentText, TitleText }) => (
  <Popover id="popover-basic">
    <Popover.Title as="h3">{TitleText}</Popover.Title>
    <Popover.Content>{ContentText}</Popover.Content>
  </Popover>
);
export function PopoversBootrap(props) {
  let { contentText, titleText, trigger, placement, children } = props;
  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      overlay={popover({ ContentText: contentText, TitleText: titleText })}
    >
      {children}
    </OverlayTrigger>
  );
}
